import { formatFontFamily as formatFontFamilyUtil } from './fontSystem';

export function getThemeForSection(section: string, sectionSettings: any, darkPrimary: any, lightPrimary: any) {
  const settings = sectionSettings[section] || { surface: "light", primary: "light" };
  return settings.primary === "dark" ? { ...darkPrimary, surface: "dark" } : { ...lightPrimary, surface: "light" };
}

export function createGradientStyle(gradStart: string, gradEnd: string, angle: number) {
  return {
    background: `linear-gradient(${angle}deg, ${gradStart}, ${gradEnd})`
  };
}

export function formatFontFamily(fontFamily: string) {
  return formatFontFamilyUtil(fontFamily);
}
